import { forwardRef, useEffect, useState, type FC } from "react";
import { Button, Form, Input, Loader, Modal, Uploader } from "rsuite";
import { ProductCategory } from "../../../models/inventory/product_category";
import { asyncLocalStorage } from "../../../utils/storage";
import { errorToast, successToast } from "../../../utils/helper-ui";
import { BsCamera } from "react-icons/bs";
import { IconBase } from "react-icons";
import { GrAttachment } from "react-icons/gr";

interface ProductCategoryFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProductCategory) => void;
  productCategory?: ProductCategory;
}

const ProductCategoryForm: FC<ProductCategoryFormProps> = ({
  open,
  onClose,
  onSubmit,
  productCategory,
}) => {
  const [uploading, setUploading] = useState(false);
  const [token, setToken] = useState("");
  const [data, setData] = useState<ProductCategory>({
    id: "",
    name: "",
    description: "",
  });
  useEffect(() => {
    asyncLocalStorage.getItem("token").then((token) => {
      setToken(token);
    });
  }, []);
  useEffect(() => {
    setData(
      productCategory || {
        id: "",
        name: "",
        description: "",
      }
    );
  }, [productCategory]);
  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>Product Category Form</Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="Name"
              value={data.name}
              onChange={(value, event) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Icon</label>

            <Uploader
              fileListVisible={false}
              listType="picture"
              accept="image/*"
              action={process.env.REACT_APP_API_URL + "/v1/file/upload"}
              onUpload={(file) => {
                setUploading(true);
              }}
              headers={{
                Authorization: `Bearer ${token}`,
              }}
              onSuccess={(response, file) => {
                setUploading(false);
                successToast("File uploaded successfully");
                setData({ ...data, icon_url: response.file.url });
              }}
              onError={() => {
                setUploading(false);
                errorToast("Upload failed");
              }}
            >
              <button style={{ width: 150, height: 150, backgroundColor: data?.color }}>
                {uploading && <Loader backdrop center />}
                {data.icon_url ? (
                  <img src={data.icon_url} width="40" height="40" />
                ) : (
                  <GrAttachment className="text-white" style={{ fontSize: 40 }} />
                )}
              </button>
            </Uploader>
          </div>
          <div className="form-group">
            <label>Color</label>
            <div className="input">
              <Input
                name="color"
                placeholder="Name"
                value={data.color}
                type="color"
                className="color-picker"
                onChange={(value, event) => setData({ ...data, color: value })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Description</label>
            <Input
              as={"textarea"}
              rows={5}
              name="description"
              placeholder="Description"
              value={data.description}
              onChange={(value, event) =>
                setData({ ...data, description: value })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button appearance="primary" onClick={() => {
            onSubmit(data!)
            setData({
              id: "",
              name: "",
              description: "",
              icon_url: "",
              color: "",
            });
          }}>
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ProductCategoryForm;
